import { ValueOf } from 'types/global';
import { SettingsRadioItem } from 'modules/settingsContainer/SettingsRadio/types';

export type ColorStrategySankeyTypeType = 'visualization' | 'levels' | 'nodes';

export const colorStrategySankey: Record<ColorStrategySankeyTypeType, ColorStrategySankeyTypeType> = {
  visualization: 'visualization',
  levels: 'levels',
  nodes: 'nodes',
};

export type ColorStrategySankeyType = ValueOf<typeof colorStrategySankey>;

export const colorStrategySankeyOptions: SettingsRadioItem<ColorStrategySankeyType>[] = [
  { value: colorStrategySankey.visualization, label: 'Визуализации' },
  { value: colorStrategySankey.levels, label: 'Уровни' },
  // { value: colorStrategySankey.nodes, label: 'Узлы' },
];

export const connectionColorSankey = {
  source: 'source',
  target: 'target',
  gradient: 'gradient',
};

export type ConnectionColorSankeyType = ValueOf<typeof connectionColorSankey>;

export const connectionColorSankeyOptions: SettingsRadioItem<ConnectionColorSankeyType>[] = [
  { value: connectionColorSankey.source, label: 'Источник' },
  { value: connectionColorSankey.target, label: 'Цель' },
  { value: connectionColorSankey.gradient, label: 'Градиент' },
];
